module.exports = __webpack_public_path__ + "media/images/icon_tab2_off-92c693d57ce1bab306f47840619208de.png";